<template>
  <div class="mianDiv">
    <div v-show="!sendSuccess">
      <van-cell-group title=" ">
        <van-cell
          is-link
          title-class="txl"
          title="分别发送给"
          :value="invokeSelectStr"
          @click="showInvoke"
        />
      </van-cell-group>
      <van-cell-group title=" ">
        <van-field
          v-model="message"
          rows="4"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          placeholder="在此输入文字内容"
          show-word-limit
        />
        <van-cell title-class="txl">
          <template #title>
            <div class="fileResuleList">
              <div
                v-for="(item, index) in fileList"
                :key="index"
                class="van-uploader__preview wh80 disb"
              >
                <!-- 小图 -->
                <div class="van-image van-uploader__preview-image wh80">
                  <van-image
                    v-if="item.file.type.indexOf('image') >= 0"
                    width="80px"
                    height="80px"
                    fit="cover"
                    :src="item.content"
                  />
                  <van-image
                    v-if="item.file.type.indexOf('video') >= 0"
                    width="80px"
                    height="80px"
                    fit="cover"
                    :src="vUrl"
                  />
                </div>
                <!-- 删除 -->
                <div
                  v-if="Number(item.type) == 2 || Number(item.type) == 3"
                  class="van-uploader__preview-delete"
                  @click="delFileList(index)"
                >
                  <i
                    class="van-icon van-icon-cross van-uploader__preview-delete-icon"
                  ></i>
                </div>
                <!-- 等待上传或者上传中 -->
                <div v-if="Number(item.type) != 2" class="van-uploader__mask">
                  <div
                    class="van-loading van-loading--circular van-uploader__loading"
                  >
                    <span
                      class="van-loading__spinner van-loading__spinner--circular"
                      ><svg viewBox="25 25 50 50" class="van-loading__circular">
                        <circle
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                        ></circle></svg
                    ></span>
                  </div>
                  <div
                    v-if="Number(item.type) == 1"
                    class="van-uploader__mask-message"
                  >
                    上传中...
                  </div>
                  <div
                    v-if="Number(item.type) == 0"
                    class="van-uploader__mask-message"
                  >
                    等待中...
                  </div>
                  <div
                    v-if="Number(item.type) == 4"
                    class="van-uploader__mask-message"
                  >
                    上传失败
                  </div>
                </div>
              </div>
            </div>
            <div class="fileDiv" @click="show = true">
              <van-icon name="plus" class="plus" />
              <span class="custom-title">添加图片、视频</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>

      <div class="pl16 pr16 mt24">
        <van-button
          v-if="
            userId.length > 0 && (message.length > 0 || fileList.length > 0)
          "
          type="info"
          size="large"
          @click="sendMsg"
          >发送</van-button
        >
        <van-button v-else disabled type="info" size="large" @click="sendMsg"
          >发送</van-button
        >
      </div>

      <p class="pl16 pr16 mt24"></p>

      <van-action-sheet v-model="show" title="选择类型">
        <van-cell-group>
          <van-cell center value-class="txc">
            <van-uploader
              ref="imageUpload"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              accept="image/*"
              :preview-image="previewImage"
            >
              <span>图片</span>
            </van-uploader>
          </van-cell>
          <van-cell center value-class="txc">
            <van-uploader
              ref="videoUpload"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              accept="video/*"
              :preview-image="previewImage"
            >
              <span>视频</span>
            </van-uploader>
          </van-cell>
        </van-cell-group>
      </van-action-sheet>
    </div>
    <MessageSuccess
      v-show="sendSuccess"
      msg="机器人已接受任务请求，请留意消息推送，授权机器人执行任务"
    ></MessageSuccess>
    <wxExternalContact
      v-show="showWxExternalContact"
      :initUser="exUser"
      :getDataUrl="exUserGetDataUrl"
      :labelUrl="labelUrl"
      @wxExcomfireSelect="wxExcomfireSelect"
    ></wxExternalContact>
  </div>
</template>
<script>
// import http from "../assets/js/http";
// import initJSSDK from "../assets/js/initJSSDK";
// import { Toast } from "vant";
import MessageSuccess from "../../components/tips/messageSuccess";
import wxExternalContact from "../../components/wxExternalContact";
export default {
  data() {
    return {
      invokeSelectStr: "选择联系人",
      message: "",
      userId: [],
      fileList: [],
      show: false,
      sendSuccess: false,
      previewImage: false,
      uploading: false,
      actions: [
        { name: "图片", value: "image/*" },
        { name: "视频", value: "video/*" }
      ],
      vUrl: require("./assets/img/v-icon.png"),
      exUser: [],
      exUserGetDataUrl: "/index.php?model=mass_message&m=index&cmd=101",
      labelUrl: "/index.php?model=mass_message&m=index&cmd=102",
      showWxExternalContact: false
    };
  },
  components: {
    MessageSuccess,
    wxExternalContact
  },
  methods: {
    wxExcomfireSelect(selectuser) {
      this.showWxExternalContact = false;
      console.log(selectuser);
      this.userId = [];
      for (let i = 0; i < selectuser.length; i++) {
        let item = selectuser[i];
        this.userId.push(item.external_userid);
      }
      if (this.userId.length > 0) {
        this.invokeSelectStr = "已选择" + this.userId.length + "人";
      } else {
        this.invokeSelectStr = "选择联系人";
      }
    },
    showInvoke() {
      this.showWxExternalContact = true;
      // let that = this;
      // window.wx.invoke(
      //   "selectExternalContact",
      //   {
      //     filterType: 0
      //   },
      //   function(res) {
      //     that.userId = res.userIds;
      //     that.invokeSelectStr = "已选择" + that.userId.length + "人";
      //     console.log(res);
      //   }
      // );
    },
    async afterRead(files) {
      console.log("afterRead", files);
      let uploadFileList = [];
      if (!Array.isArray(files)) {
        uploadFileList = [files];
      } else {
        uploadFileList = files;
      }
      for (let i = 0; i < uploadFileList.length; i++) {
        let fileItem = uploadFileList[i];
        fileItem.type = 0;
        this.fileList.push(fileItem);
      }
      this.show = false;
      this.uploading = true;
      for (let i = 0; i < this.fileList.length; i++) {
        let fileItem = this.fileList[i];
        if (fileItem.uploadRes == undefined) {
          fileItem.type = 1;
          const data = new FormData();
          data.append("file", fileItem.file);
          await this.$common
            .http({
              url: "/index.php?model=upload&cmd=101",
              file: data,
              noLoading: true
            })
            .then(res => {
              if (Number(res.data.errcode) === 0) {
                fileItem.type = 2;
              } else {
                fileItem.type = 4;
              }
              fileItem.uploadRes = res.data;
              console.log(res);
            });
        }
      }
      this.uploading = false;
    },
    beforeRead(files) {
      console.log("beforeRead", files);
      return true;
    },
    sendMsg() {
      if (this.uploading) {
        return;
      }
      let files = [];
      for (let i = 0; i < this.fileList.length; i++) {
        let fileItem = this.fileList[i];
        if (Number(fileItem.type) === 2) {
          files.push(fileItem.uploadRes);
        }
      }
      this.$common
        .http({
          url: "/index.php?model=mass_message&m=ajax&cmd=101",
          data: {
            data: JSON.stringify({
              content: this.message,
              ex_userids: this.userId,
              files
            })
          }
        })
        .then(res => {
          this.sendSuccess = true;
          console.log(res);
        });
    },
    delFileList(index) {
      if (this.uploading) {
        return;
      }
      this.fileList.splice(index, 1);
    }
  },
  created() {
    // Toast.loading({
    //   message: "",
    //   forbidClick: true,
    //   duration: 0
    // });
    // initJSSDK();
    // Toast.clear();
  }
};
</script>
<style lang="less" scoped>
.mianDiv {
  height: 100vh;
  overflow: auto;
}
.txl {
  text-align: left;
}
.txc {
  text-align: center;
}
.hide {
  display: none;
}
.fileDiv {
  display: flex;
  align-items: center;
}
.plus {
  width: 50px;
  height: 50px;
  border: 1px solid #f4f4f4;
  font-size: 35px;
  line-height: 50px;
  text-align: center;
  color: #f4f4f4;
  margin-right: 10px;
}
.fileResuleList {
  .wh80 {
    width: 80px;
    height: 80px;
  }
  .disb {
    display: inline-block;
  }
}
.van-action-sheet {
  .van-cell {
    padding: 0;
  }
}
.van-uploader {
  width: 100%;
  box-sizing: border-box;
  .van-uploader__wrapper {
    justify-content: center;
  }
}
</style>
<style lang="less">
.mianDiv {
  .van-action-sheet {
    .van-uploader__wrapper {
      justify-content: center;
    }
    .van-uploader__input-wrapper {
      width: 100%;
      padding: 10px 16px;
    }
  }
}
</style>
